<template>
  <div class="productinfo-page">
    <div class="commonpageheader">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{name: 'Subscription'}">订阅管理</el-breadcrumb-item>
        <el-breadcrumb-item>标准信息表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="table-toolbar">
      <el-row :gutter="15">
        <el-col :span="16">
          <div class="table-toolbar-left">   
            <el-input size="small" @keyup.enter.native="getProductInfoList()" v-model="query.search" placeholder="请输入SKUID、商品名称或SKUCode"></el-input>
            <div class="table-toolbar-left-inner">
              <ul>
                <li>已匹配: <em>{{ matchcount.MatchCount }}</em></li>
                <li>待匹配: <em>{{ matchcount.UnMatch }}</em></li>
                <li>
                  <span>匹配完成率:</span>
                  <div class="el-progress-box">
                    <el-progress :text-inside="true" :stroke-width="16" :percentage="matchcount.MatchRate"></el-progress>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="table-toolbar-right">
            <el-button type="primary" plain @click="importsku()" size="small">导入SKU</el-button>
            <el-tooltip v-if="showsyncbtn" class="item" effect="dark" content="查询待同步数据" placement="top">
              <el-button plain :loading="syncskubtn" type="primary" @click="getskusyncCount()" size="small">查询</el-button>
            </el-tooltip>
            <el-button v-if="!showsyncbtn" :loading="syncskubtn1" type="danger" @click="syncSku()" size="small">立即同步({{ skusyncnumber }})</el-button>
            <el-popconfirm confirm-button-text="执行" cancel-button-text="取消" title="确定批量立即执行吗？" @confirm="activeRule()">
              <el-button type="danger" size="small" slot="reference" style="margin-left: 10px; margin-right: 10px;">批量立即执行</el-button>
            </el-popconfirm>            
            <el-button type="warning" @click="downloadexcel()" size="small">下载</el-button>
            <el-button v-if="!disabled3" type="primary" @click="addProductInfoList()" size="small">添加</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="tablebox">
      <el-table 
        :cell-style="getCellStyle"
        v-loading="loading"
        :data="tablelist"
        tooltip-effect="dark"
        size="small"
        @cell-dblclick="editSinglePrcie"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop='id' label="SKUID" width="60"></el-table-column>
        <el-table-column prop='brand' label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop='series' label="系列" show-overflow-tooltip></el-table-column>
        <el-table-column prop='productName' label="商品名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop='model' label="型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop='specification' label="参数" show-overflow-tooltip></el-table-column>
        <el-table-column prop="skucode" label="用戶SKUCode" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="常规监测价">
          <template slot-scope="scope">
            <span v-if="scope.row.isedittype ===  false">{{scope.row.price}}</span>
            <el-input 
              v-inputfocus
              onkeyup="value=value.replace(/[^0-9.]/g,'')" 
              class="editpriceinput" 
              v-model="scope.row.price" 
              v-if="scope.row.isedittype === true" 
              @blur="savePrice(scope.row.id, scope.row.price, scope.row)"
              @keyup.enter.native="savePrice(scope.row.id, scope.row.price, scope.row)"
              size="mini">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column prop="Unchecked" label="未读" width="70px" show-overflow-tooltip></el-table-column>
        <el-table-column prop='updateTime' label="上次更新" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" :width="!disabled3 ? 450 : 300"><!-- +100px -->
          <template slot-scope="scope">
            <el-button type="warning" size="mini" @click="goToSKUURLMatchingManager(scope.row.id)">匹配规则</el-button>
            <el-button type="success" size="mini" @click="goToMatchResultConsole(scope.row.id)">匹配结果</el-button>
            <el-button v-if="!disabled3" :disabled="scope.row.skutype * 1 == 1" type="primary" size="mini" @click="editProductInfoList(scope.row)">修改</el-button>
            <el-popconfirm v-if="!disabled3" confirm-button-text="删除" cancel-button-text="取消" title="确定删除吗？" @confirm="delProductInfoList(scope.row.id)">
              <el-button type="warning" :disabled="scope.row.skutype * 1 == 1" slot="reference" size="mini">删除</el-button>
            </el-popconfirm>
            <el-button class="listbtngroup" type="btnsticky" size="mini" @click="sortSku(scope.row, scope.$index, 1)"
              v-if="scope.row.type == null || scope.type == '' || scope.row.type/1 == 1"></el-button>
            <el-button class="listbtngroup" type="btnunsticky" size="mini" @click="sortSku(scope.row, scope.$index, 1)"
              v-if="scope.row.type/1 == 2"></el-button>
            <el-button class="listbtngroup" type="btnarrowup" size="mini" @click="sortSku(scope.row, scope.$index, 20)"
              v-if="scope.row.type/1 == 2" :disabled="scope.$index/1 === 0"></el-button>
            <el-button class="listbtngroup" type="btnarrowdown" size="mini" @click="sortSku(scope.row, scope.$index, 21)"
              v-if="scope.row.type/1 == 2" :disabled="scope.$index/1 === totalsticky - 1"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="table-pagination">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        popper-class="pagesizeclass"
        :page-sizes="[25, 50, 100]"
        :page-size="query.size"
        layout="total, prev, pager, next, sizes"
        :total="totalbrand">
      </el-pagination>      
    </div>

    <el-dialog
      title="修改标准信息"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="editBrandDialog"
      width="500px">
      <div class="edit-form">
        <el-form :model="editform" :rules="productinforules" ref="editproductinfo" label-width="120px" size="mini">
          <el-form-item label="订阅ID">
            <el-col :span="24">
              <el-input v-model="editform.id" :disabled="true"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌">
            <el-col :span="24">
              <el-input v-model="editform.brand" :disabled="true"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="商品名" prop="productName">
            <el-col :span="24">
              <el-input v-model="editform.productName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="商品简介">
            <el-col :span="24">
              <el-input v-model="editform.description"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="别名">
            <el-col :span="24">
              <el-input v-model="editform.shortName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="系列">
            <el-col :span="24">
              <el-input v-model="editform.series"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="型号">
            <el-col :span="24">
              <el-input v-model="editform.model"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="参数">
            <el-col :span="24">
              <el-input v-model="editform.specification"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="用戶SKUCode">
            <el-col :span="24">
              <el-input v-model="editform.skucode"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="常规监测价" prop="price">
            <el-col :span="24">
              <el-input v-model="editform.price" onkeyup="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loadingbtn" @click="cancelDialog()" size="small">取 消</el-button>
        <el-button :loading="loadingbtn" type="primary" @click="confirmEdit('editproductinfo')" size="small">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="新增标准信息"
      custom-class="editdialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :visible.sync="addBrandDialog"
      width="500px">
      <div class="edit-form">
        <el-form :model="addform" :rules="productinforules" ref="addproductinfo" label-width="120px" size="mini">
          <el-form-item label="订阅ID">
            <el-col :span="24">
              <el-input v-model="addform.subid" :disabled="true"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌">
            <el-col :span="24">
              <el-input v-model="addform.brand" :disabled="true"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="商品名" prop="productName">
            <el-col :span="24">
              <el-input v-model="addform.productName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="商品简介">
            <el-col :span="24">
              <el-input v-model="addform.description"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="别名">
            <el-col :span="24">
              <el-input v-model="addform.shortName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="系列">
            <el-col :span="24">
              <el-input v-model="addform.series"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="型号">
            <el-col :span="24">
              <el-input v-model="addform.model"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="参数">
            <el-col :span="24">
              <el-input v-model="addform.specification"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="用戶SKUCode">
            <el-col :span="24">
              <el-input v-model="addform.skucode"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="常规监测价" prop="price">
            <el-col :span="24">
              <el-input v-model="addform.price" onkeyup="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="loadingbtn" @click="cancelDialog()" size="small">取 消</el-button>
        <el-button :loading="loadingbtn" type="primary" @click="confirmAdd('addproductinfo')" size="small">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {

  data(){
    return{
      loading: true,
      taskid: this.$route.params.subid,
      query: {
        subid: this.$route.params.subid,
        search: '',
        page: this.$route.query.page ? this.$route.query.page/1 : 1,
        size: this.getLocalStorage('pagesize6') ? this.getLocalStorage('pagesize6') * 1 : 25,
      },
      currentPage: this.$route.query.page ? this.$route.query.page/1 : 1,
      tablelist: [],
      totalbrand: 0,
      editBrandDialog: false,
      addBrandDialog: false,
      loadingbtn: false,
      editform: {
        id: '',
        productName: '',
        brand: '',
        industry: '',
        category: '',
        series: '',
        model: '',
        specification: '',
        description: '',
        shortName: '',
        skucode: '',
        price: ''
      },
      addform: {
        subid: '',
        productName: '',
        brand: '',
        industry: '',
        category: '',
        series: '',
        model: '',
        specification: '',
        description: '',
        shortName: '',
        skucode: '',
        price: ''
      }, 
      baseinfo: '',
      matchcount: {},
      productinforules: {
        productName: { required: true, message: '不能为空', trigger: 'blur' },
        price: [
          { required: true, message: '不能为空' },
          // { type: 'number', message: '价格必须为数值' }
        ]
      },
      pageheight: '', /* 获取屏幕可视区高度，固定表格标题 */
      topnuminfo: {
        checkednum: '',
        pendingchecknum: '',
        checkpercent: 0
      },
      disabled1: this.getLocalStorage('level')/1 === 1 ? true : false,
      disabled3: this.getLocalStorage('level')/1 === 3 ? true : false,
      totalsticky: 0,
      skusyncnumber: 0,
      syncskubtn: false,
      syncskubtn1: false,
      showsyncbtn: true
    }
  },

  mounted(){
    // this.getskusyncCount()
    this.getMatchCount()
    this.getBaseInfo()
    this.getProductInfoList()
  },

  methods: {

    tableRowClassName({row, rowIndex}) {
      if (row.type/1 === 2) {
        if (rowIndex == this.totalsticky/1 - 1) {
          return 'sticky-row sticky-row-last'
        }
        return 'sticky-row'
      }
      return ''
    },

    getCellStyle({ column }) {
      const tempWidth = column.realWidth || column.width
      if (column.showOverflowTooltip) {
        return {
          minWidth: tempWidth + 'px',
          maxWidth: tempWidth + 'px'
        }
      }

      return {}
    },

    /**
     * 切换每页显示条目数
     */
    handleSizeChange(val) {
      let that = this
      that.currentPage = 1
      that.query.page = 1
      that.query.size = val
      that.setLocalStorage('pagesize6', val)
      that.getProductInfoList()
    },

    /**
     * 切换分页
     */
    handleCurrentChange(val) {
      let that = this
      that.query.page = val
      this.$router.replace({
        query:{
          page: val
        }
      })
      that.getProductInfoList()
    },

    /**
     * 获取订阅基本信息
     */
    getBaseInfo: function(){
      let that = this
      let url = that.API_URL + '/sys/match/view'
      let query = {subid: that.query.subid}
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBaseInfo', data)
          let info = data.results[0]
          that.baseinfo = info
          that.topnuminfo.checkednum = that.millonFormat(data.results[0].MatchCount)
          that.topnuminfo.pendingchecknum = that.millonFormat(data.results[0].UnMatch)
          that.topnuminfo.checkpercent = data.results[0].MatchRate
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },
    
    /**
     * 获取匹配条数
     */
    getMatchCount: function(){
      let that = this
      let url = that.API_URL + '/sys/match/MatchCount'
      let query = {subid: that.query.subid}
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getBaseInfo', data)
          let matchcount = data.results
          matchcount.MatchRate = (data.results.MatchRate)/1
          that.matchcount = matchcount
        },
        error: function(response) {
          console.log('getBaseInfo', response)
        }
      })
    },

    /**
     * 信息列表
     */
    getProductInfoList: function(){
      let that = this
      let url = that.API_URL + '/sys/monitor/list'
      let query = that.query
      that.loading = true
      that.tablelist = []
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('getProductInfoList', data)
          that.totalbrand = data.results[0][0].Count
          let lists = data.results[1]
          lists.forEach(function(res){
            res.insertTime = that.$moment(res.insertTime).utc().local().format('YYYY-MM-DD hh:mm')
            res.updateTime = res.updateTime == '' || res.updateTime == null ? '' : that.$moment(res.updateTime).utc().local().format('MM-DD hh:00')
            res.isedittype = false
          })
          let _t = 0
          for(let j=0; j<lists.length; j++){
            if(lists[j].type/1 ==2){
              _t += 1
            }
          }
          that.totalsticky = _t
          that.tablelist = lists
          that.loading = false
        },
        error: function(response) {
          console.log('getProductInfoList', response)
        }
      })
    },

    /**
     * 隐藏对话框
     */
    cancelDialog: function(){
      let that = this
      that.editform = {
        id: '',
        productName: '',
        brand: '',
        industry: '',
        category: '',
        series: '',
        model: '',
        specification: '',
        description: '',
        shortName: '',
        skucode: '',
        price: ''
      },
      that.addform = {
        subid: '',
        productName: '',
        brand: '',
        industry: '',
        category: '',
        series: '',
        model: '',
        specification: '',
        description: '',
        shortName: '',
        skucode: '',
        price: ''
      },
      that.loadingbtn = false
      that.editBrandDialog = false
      that.addBrandDialog = false
    },

    /**
     * 修改弹窗
     */
    editProductInfoList: function(obj){
      let that = this
      let _obj = {}
      _obj = JSON.parse(JSON.stringify(obj))
      that.editBrandDialog = true
      that.editform.brand = that.baseinfo.brandName
      that.editform = _obj
    },

    /**
     * 添加弹窗
     */
    addProductInfoList: function(){
      let that = this
      that.addform.subid = that.$route.params.subid
      that.addform.brand = that.baseinfo.brandName
      that.addBrandDialog = true
    },

    /**
     * 确定修改
     */
    confirmEdit: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          that.loadingbtn = true
          let url = that.API_URL + '/sys/monitor/edit'
          let query = {
            id: that.editform.id,
            productName: that.editform.productName,
            brand: that.editform.brand,
            industry: that.editform.industry,
            category: that.editform.category,
            series: that.editform.series,
            model: that.editform.model,
            specification: that.editform.specification,
            description: that.editform.description,
            shortName: that.editform.shortName,
            skucode: that.editform.skucode,
            price: isNaN(that.editform.price * 1) ? that.editform.price.replace(/[^0-9.]/g,'') : that.editform.price
          }
          $.ajax({
            url: url,
            type: "PUT",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('confirmEdit', data)
              that.cancelDialog()
              that.getProductInfoList()
            },
            error: function(response) {
              console.log('confirmEdit', response)
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * 确定添加
     */
    confirmAdd: function(refs){
      let that = this
      that.$refs[refs].validate(function(valid){
        if(valid){
          that.loadingbtn = true
          let url = that.API_URL + '/sys/monitor/add'
          let query = {
            subid: that.addform.subid,
            productName: that.addform.productName,
            brand: that.addform.brand,
            industry: that.addform.industry,
            category: that.addform.category,
            series: that.addform.series,
            model: that.addform.model,
            specification: that.addform.specification,
            description: that.addform.description,
            shortName: that.addform.shortName,
            skucode: that.addform.skucode,
            price: isNaN(that.addform.price * 1) ? that.addform.price.replace(/[^0-9.]/g,'') : that.addform.price
          }
          $.ajax({
            url: url,
            type: "POST",
            headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
            changeOrigin: true,
            crossDomain: true,
            data: query,
            success: function(data) {
              console.log('confirmAdd', data)
              that.cancelDialog()
              that.getProductInfoList()
            },
            error: function(response) {
              console.log('confirmAdd', response)
            }
          })
        }else{
          return false
        }
      })
    },

    /**
     * 删除信息
     */
    delProductInfoList: function(id){
      let that = this
      let url = that.API_URL + '/sys/monitor/ban'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {id: id},
        success: function(data) {
          console.log('confirmAdd', data)
          that.getProductInfoList()
        },
        error: function(response) {
          console.log('confirmAdd', response)
        }
      })
    },

    /**
     * 修改行内价格
     */
    editSinglePrcie: function(row, column){
      if(column.label === '常规监测价'){
        row.isedittype = true
      }
    },

    /**
     * 保存行内价格修改
     */
    savePrice: function(id, price, row){
      let that = this
      if(price===''){
        return 
      }
      let url = that.API_URL + '/sys/monitor/price'
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        data: {id: id, price: price},
        success: function(data) {
          console.log('savePrice', data)
          row.isedittype = false
        },
        error: function(response) {
          console.log('savePrice', response)
        }
      })
    },

    /**
     * 匹配规则
     */
    goToSKUURLMatchingManager: function(skuid){
      let that = this
      that.setLocalStorage('currentpage', that.query.page)
      that.$router.push({name: 'SKUURLMatchingManager',params: {subid: that.$route.params.subid, poid: that.$route.params.poid, skuid: skuid}})
    },

    /**
     * 匹配结果
     */
    goToMatchResultConsole: function(skuid){
      let that = this
      that.setLocalStorage('currentpage', that.query.page)
      that.$router.push({name: 'MatchResultConsole',params: {subid: that.$route.params.subid, poid: that.$route.params.poid, skuid: skuid}})
    },

    /**
     * 修改排序
     */
    sortSku: function(row, _index, len){
      console.log(row)
      console.log(_index)
      let that = this
      let url = that.API_URL + '/sys/monitor/editSort'
      let _arr = []
      if(row.type == '' || row.type == null || row.type/1 == 1){
        _arr = [{
          skuid: row.id, 
          sort: -1
        }]
      }
      if(row.type/1 == 2 && len == 1){
        _arr = [{
          skuid: row.id, 
          sort: ''
        }]
      }
      if(row.type/1 == 2 && len == 20){
        _arr = [{
          skuid: that.tablelist[_index].id,
          sort: row.sort - 1
        },{
          skuid: that.tablelist[_index-1].id, 
          sort: row.sort
        }]
      }
      if(row.type/1 == 2 && len == 21){
        _arr = [{
          skuid: that.tablelist[_index].id,
          sort: row.sort + 1
        },{
          skuid: that.tablelist[_index+1].id, 
          sort: row.sort
        }]
      }
      let query = {
        baseinfoList: JSON.stringify(_arr),
        taskid: row.projectId
      }
      $.ajax({
        url: url,
        type: "PUT",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        traditional: true,
        changeOrigin: true,
        crossDomain: true,
        data: query,
        success: function(data) {
          console.log('sortSku', data)
          that.getProductInfoList()
        },
        error: function(response) {
          console.log('sortSku', response)
        }
      })
    },

    /**
     * 下载
     */
    downloadexcel: function(){
      let that = this
      let filenametime = that.$moment(new Date(),'YYYY-MM-DDTHH:mm:ss.SSS').format('YYYYMMDDHHmm')
      let url = that.API_URL
                  +'/sys/monitor/downlist?subid=' + that.query.subid 
                  +'&page=1'
                  +'&size=25'
                  +'&search='
      let filename = that.tablelist[0].brand
      let xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.setRequestHeader("Authorization", 'Bearer '+JSON.parse(localStorage.getItem("token")).val+'')
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (this.status === 200) {
          var blob = this.response;
          var reader = new FileReader()
          reader.readAsDataURL(blob)
          reader.onload = function (e) {
            var a = document.createElement('a')
            a.download = filename + '_标准信息表_' + filenametime+'.xlsx'
            a.href = e.target.result
            $("body").append(a)
            a.click()
            $(a).remove()
            that.downloading = false
          }
        }
      }
      xhr.send()
      // let url = that.API_URL + '/sys/monitor/downlist'
      // let query = that.query
      // $.ajax({
      //   url: url,
      //   type: "GET",
      //   headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
      //   changeOrigin: true,
      //   crossDomain: true,
      //   data: query,
      //   success: function(data) {
      //     console.log('downloadexcel', data)
      //   },
      //   error: function(response) {
      //     console.log('downloadexcel', response)
      //   }
      // })
    },

    /**
     * 获取订阅需要同步的数量
     */
    getskusyncCount: function(){
      let that = this
      let url = that.API_URL + '/sys/databaseinfo/getskusyncCount?taskId=' + that.taskid
      that.syncskubtn = true
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          console.log('getskusyncCount', data)
          that.skusyncnumber = data.results[0].Count
          that.syncskubtn = false
          if(that.skusyncnumber == 0){
            that.$message({
              message: '暂无待同步数据',
              type: 'warning'
            })
          } else{
            that.showsyncbtn = false
          }
        },
        error: function(response) {
          console.log('getskusyncCount', response)
        }
      })
    },

    /**
     * 立即同步
     */
    syncSku: function(){
      let that = this
      let url = that.API_URL + '/sys/databaseinfo/skusync?taskId=' + that.taskid
      that.syncskubtn1 = true
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          console.log('syncSku', data)
          that.$message({
            message: '同步请求已发出',
            type: 'success'
          })
          that.showsyncbtn = true
          that.syncskubtn1 = false
        },
        error: function(response) {
          console.log('getskusyncCount', response)
        }
      })
    },

    /**
     * 立即执行所有匹配规则
     */
    activeRule: function(){
      let that = this
      let url = that.API_URL + '/sys/rule/activeAll?taskId=' + that.taskid
      $.ajax({
        url: url,
        type: "GET",
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(data) {
          console.log('syncSku', data)
          that.$message({
            message: '执行请求已发出',
            type: 'success'
          })
        },
        error: function(response) {
          console.log('getskusyncCount', response)
        }
      })
    },

    /**
     * 跳转至导入SKU，自动获取关键词
     */
    importsku: function(){
      this.$router.push({name: 'NewSKU',params: {taskid: this.taskid}})
    },

  }
}
</script>
